<template>
  <footer class="footer" v-if="$route.name !== 'Sequences'">
    <div class="footer-content">
      <!-- Top Section: Main Footer Content -->
      <div class="footer-top">
        <!-- About Section -->
        <div class="footer-column">
          <h4 class="footer-heading">About</h4>
          <ul class="footer-links">
            <li>
              <a href="/about/overview" tabindex="0">About TAIR</a>
            </li>
            <li>
              <a
                href="https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216364/Our+Team"
                target="_blank"
                tabindex="0"
                >Our Team</a
              >
            </li>
            <li>
              <a
                href="https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42217301/Release+Notes"
                target="_blank"
                tabindex="0"
                >Release Notes</a
              >
            </li>
            <li>
              <a
                href="https://omniform1.com/forms/v1/landingPage/68a794a2cfa3b70cffc67d21/68a7aa40d1e73f776385b2ec"
                target="_blank"
                tabindex="0"
                >Get Email Updates</a
              >
            </li>
          </ul>
        </div>

        <!-- Contact Section -->
        <div class="footer-column">
          <h4 class="footer-heading">Contact</h4>
          <div class="contact-info">
            <p>
              <a href="mailto:curator@arabidopsis.org" class="email-link">
                <i class="fas fa-envelope" aria-hidden="true"></i>
                curator@arabidopsis.org
              </a>
            </p>
            <p class="organization">Phoenix Bioinformatics Corporation</p>
            <p class="address">39899 Balentine Drive, Suite 200</p>
            <p class="address">Newark, CA 94560, USA</p>
          </div>
        </div>

        <!-- Connect Section -->
        <div class="footer-column connect-column">
          <h4 class="footer-heading">Connect</h4>
          <div class="social-container">
            <a
              href="https://www.facebook.com/tairnews"
              target="_blank"
              class="social-icon"
              aria-label="Facebook"
              tabindex="0"
            >
              <i class="fab fa-facebook" aria-hidden="true"></i>
            </a>
            <a
              href="https://www.youtube.com/channel/UCqYlBTnoVz6s1beB058lBqQ"
              target="_blank"
              class="social-icon"
              aria-label="YouTube"
              tabindex="0"
            >
              <i class="fab fa-youtube" aria-hidden="true"></i>
            </a>
            <a
              href="https://bsky.app/profile/tairnews.bsky.social"
              target="_blank"
              class="social-icon"
              aria-label="Bluesky"
              tabindex="0"
            >
              <i class="fa-brands fa-bluesky" aria-hidden="true"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/phoenix-bioinformatics"
              target="_blank"
              class="social-icon"
              aria-label="LinkedIn"
              tabindex="0"
            >
              <i class="fab fa-linkedin" aria-hidden="true"></i>
            </a>
          </div>
          <div class="phoenix-logo-wrapper">
            <a
              href="https://phoenixbioinfo.org/"
              target="_blank"
              class="phoenix-logo"
            >
              <img
                src="@/public/phoenix-logo.png"
                alt="Phoenix Bioinformatics logo"
              />
            </a>
          </div>
        </div>
      </div>

      <!-- Bottom Section: Legal Links & Copyright -->
      <div class="footer-bottom">
        <div class="footer-legal">
          <ul class="legal-links">
            <li>
              <a
                href="https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216430/TAIR+Terms+of+Use"
                target="_blank"
                tabindex="0"
                >Terms of Use</a
              >
            </li>
            <li class="separator" aria-hidden="true">|</li>
            <li>
              <a
                href="https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216420/TAIR+Licensing"
                target="_blank"
                tabindex="0"
                >Licensing</a
              >
            </li>
            <li class="separator" aria-hidden="true">|</li>
            <li>
              <a href="/accessibility" tabindex="0">Accessibility</a>
            </li>
            <li class="separator" aria-hidden="true">|</li>
            <li>
              <a href="/sitemap" tabindex="0">Site Map</a>
            </li>
          </ul>
        </div>
        <div class="footer-copyright">
          <p>
            &copy; {{ currentYear }} Phoenix Bioinformatics Corporation. All
            rights reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  background-color: #bbc9ce;
  color: #2c3e50;
  padding: 0;
  font-size: 0.9rem;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
}

// Top section with columns
.footer-top {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr;
  gap: 40px;
  padding: 25px 20px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  align-items: start;
}

.footer-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  text-align: left;
}

.footer-heading {
  color: #000;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 8px;
  }

  a {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 600;
    font-size: 0.9rem;
    transition: color 0.3s ease;
    display: inline-block;

    &:hover,
    &:focus {
      color: #1d6100;
      text-decoration: underline;
    }
  }
}

.contact-info {
  color: #2c3e50;
  line-height: 1.6;

  p {
    margin: 0 0 6px 0;
  }

  .organization {
    font-weight: bold;
    color: #000;
    margin-top: 5px;
    margin-bottom: 4px;
  }

  .address {
    font-size: 0.85rem;
    font-weight: 500;
  }
}

.email-link {
  color: #2c3e50;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: bold;
  font-size: 0.9rem;
  transition: color 0.3s ease;

  i {
    font-size: 0.9rem;
  }

  &:hover,
  &:focus {
    color: #1d6100;
    text-decoration: underline;
  }
}

.connect-column {
  align-items: flex-start;
}

.social-container {
  display: flex;
  gap: 18px;
  align-items: center;
  margin-bottom: 15px;
}

.social-icon {
  color: #2c3e50;
  font-size: 1.6rem;
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:focus {
    color: #1d6100;
    transform: scale(1.15);
  }
}

.phoenix-logo-wrapper {
  margin-top: 5px;
}

.phoenix-logo {
  display: inline-block;

  img {
    height: 50px;
    width: auto;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
}

// Bottom section with legal links
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: rgba(0, 0, 0, 0.05);
  flex-wrap: wrap;
  gap: 15px;
}

.footer-legal {
  flex: 1;
}

.legal-links {
  display: flex;
  gap: 15px;
  list-style: none;
  padding: 0;
  margin: 0;
  align-items: center;
  flex-wrap: wrap;

  li {
    margin: 0;
  }

  .separator {
    color: rgba(0, 0, 0, 0.3);
    user-select: none;
    font-weight: bold;
  }

  a {
    color: #2c3e50;
    text-decoration: none;
    font-size: 0.85rem;
    font-weight: bold;
    transition: color 0.3s ease;

    &:hover,
    &:focus {
      color: #1d6100;
      text-decoration: underline;
    }
  }
}

.footer-copyright {
  flex: 1;
  text-align: right;

  p {
    margin: 0;
    color: #2c3e50;
    font-size: 0.85rem;
    font-weight: 600;
  }
}

// Responsive design
@media (max-width: 992px) {
  .footer-top {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    padding: 20px;
  }
}

@media (max-width: 768px) {
  .footer-top {
    grid-template-columns: 1fr;
    gap: 25px;
    padding: 20px;
  }

  .footer-bottom {
    flex-direction: column;
    text-align: center;
    gap: 12px;
    padding: 12px 20px;
  }

  .footer-copyright {
    text-align: center;
  }

  .legal-links {
    justify-content: center;
  }

  .social-container {
    justify-content: flex-start;
  }

  .connect-column {
    align-items: flex-start;
  }

  .phoenix-logo-wrapper {
    text-align: left;
  }
}
</style>
